import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

type PdfNavigationContextValue = {
  targetPage: number | null;
  navigateToPage: (page: number) => void;
};

const PdfNavigationContext = createContext<PdfNavigationContextValue | undefined>(undefined);

type PdfNavigationProviderProps = {
  children: React.ReactNode;
};

export const PdfNavigationProvider = ({
  children,
}: PdfNavigationProviderProps): JSX.Element => {
  const [targetPage, setTargetPage] = useState<number | null>(null);

  const navigateToPage = useCallback((page: number) => {
    setTargetPage(page);
  }, []);

  const contextValue = useMemo<PdfNavigationContextValue>(
    () => ({
      targetPage,
      navigateToPage,
    }),
    [targetPage, navigateToPage],
  );

  return (
    <PdfNavigationContext.Provider value={contextValue}>
      {children}
    </PdfNavigationContext.Provider>
  );
};

export function usePdfNavigation(): PdfNavigationContextValue {
  const context = useContext(PdfNavigationContext);
  if (!context) {
    throw new Error("usePdfNavigation must be used within a PdfNavigationProvider");
  }
  return context;
}

export function buildPdfUrlWithPage(baseUrl: string, page: number | null): string {
  if (page === null) {
    return baseUrl;
  }
  return `${baseUrl}#page=${page}`;
}
